/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import baseFlatten from"./baseFlatten";import isFunction from"./isFunction";const pick=function(t,e,n){let i={};if(null===t)return i;if(isFunction(e))for(var l in t){let o=t[l];e.call(n,o,l,t)&&(i[l]=o)}else{let e=baseFlatten(arguments,!1,!1,1);t=new Object(t);for(let n=0,o=e.length;n<o;n++)(l=e[n])in t&&(i[l]=t[l])}return i};export default pick;